<template>
  <div class="cash-withdrawal">
    
    <div class="my-promotion">
        <div class="header" style="background-color: rgb(236, 93, 89) !important;">
            <!-- <div class="name acea-row row-center-wrapper">
                <div>累计提现</div>
            </div>
            <div class="num">{{total}}</div> -->
            <div class="name acea-row row-center-wrapper">
                <div>消费账户余额</div> 
            </div>
            <div class="num">{{now_money}}</div>
            
        </div>
    </div>
  
   <!-- <div class="bill-details">
        <div class="nav acea-row"> 
        <div class="item" :class="currentTab == 1 ? 'on' : ''" @click="swichNav(1)">
            转账记录
        </div> 
        </div>
    </div> -->
    <div class="wrapper">
     
      <div>
        <div class="sign-record">
      <div class="list nopadding">
        <div class="item" v-for="(item, index) in list" :key="index">
          <div class="data">{{ item.add_time }}</div>
          <div class="listn">
           <div class="itemn acea-row row-between-wrapper">
              <div>
                <div class="name line1">{{ getPaymentMethod(item.extract_type) }}</div> 
                   
                <div v-if="item.extract_type == 'bank'">账户：{{ item.bank_code }}</div> 
                <div v-if="item.extract_type == 'weixin'">账户：{{ item.wechat }}</div>
                <div v-if="item.extract_type == 'alipay'">账户：{{ item.alipay_code }}</div>

              </div>
              <div class="num" :class="item.status == 0 ? 'font-color-red' : ''">
                {{ item.extract_price }}
                <div class="daozhang">实际到账：{{ getDaozhang(item.extract_price) }}</div> 
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <Loading :loaded="loaded" :loading="loading"></Loading>
      </div> 
    </div>
  </div>
</template>
<script>

import { getBalance,getExtractRecord } from "../../../api/user";
import { required } from "@utils/validate";
import { validatorDefaultCatch } from "@utils/dialog";

export default {
  name: "UserExtractRecord",
  components: {},
  props: {},
  data: function() {
    return {
      navList: [
        { name: "银行卡", type: "bank", icon: "icon-yinhangqia" },
        { name: "微信", type: "weixin", icon: "icon-weixin2" },
        { name: "支付宝", type: "alipay", icon: "icon-icon34" }
      ],
      post: {
        accout: "1",
        username: "",
        money: "",
        code:""
      },
      d_money:0,
      now_money:0,
      total:0,
      currentTab: 1,
      minPrice: 100,
      banks: [], 
      real_name:'',
      where: {
        page: 1,
        limit: 10
      },
      list: [],
      loaded: false,
      loading: false,
      types:"5"
    };
  },
  mounted: function() {
    this.getBank();
    this.getList();
  },
  activated() {
    // 每次激活组件时都重新获取数据（无需判断来源）
     this.getBank();
     this.getList();
  },
  methods: {
    getPaymentMethod(code) {
      const map = {
        bank: '银行转账',
        weixin: '微信',
        alipay: '支付宝'
      };
      return map[code] || code; // 如果未知，默认返回原值
    },
    getDaozhang(newVal) {
      const amount = parseFloat(newVal) || 0;
      return amount * 0.92;  
    },
    swichNav: function(index) {
        let that = this;
      this.currentTab = index;
      if(index==1){
        that.where.page=1;
        that.list=[];
        this.getList();
      }
    }, 
    getList:function(){
        let that = this;
        getExtractRecord(that.where).then(
            res => {
            that.loading = false;
            that.loaded = res.data.length < that.where.limit;
            that.where.page = that.where.page + 1;
            that.list.push.apply(that.list, res.data);
            },
            error => {
            that.$dialog.message(error.msg);
            }
        );
    },
    getBank: function() {
      let that = this;
      getBalance().then(
        res => {
          that.now_money = res.data.now_money; 
          that.total = res.data.extractTotalPrice;
        },
        function(err) {
          that.$dialog.message(err.msg);
        }
      );
    }
  }
};
</script>

<style scoped>
   .list .item{ position: relative;}
   .cash-withdrawal .wrapper .list .item{ min-height: 1.07rem; height: auto;}
   .tips{width: 3em;
    font-size: .32rem;
    margin-left: 0.2rem;
    text-align: right;
	position: absolute;
	right: 0.1rem;
	bottom: 0.2rem;
	}
    .cash-withdrawal .wrapper .nopadding{ padding: 0;}
    .daozhang{ font-size: 0.28rem; color: #666;;}
</style>
